import React, { useState } from 'react';
import { assets } from '../assets/assets';

function Testimonials() {


      const testimonialsData = [
        {
          photo: assets.avt4, // Replace with an actual photo URL
          name: "Mammoth",
          designation: "Primal Beast",
          review: "Great quality products - These are much better than leopard skin. Fabric is comfortable and comes in various designs.",
        },
        {
          photo: assets.avt8, // Replace with an actual photo URL
          name: "Sabertooth",
          designation: "King of Wild",
          review: "Finally! This product is fit for royalty! Stylish, eco-friendly, and strong like me. Paws down, the best! Trendy designs, but the fabric isn't claw-proof.",
        },
        {
          photo: assets.avt12, // Replace with an actual photo URL
          name: "Vasuki Indicus",
          designation: "Emperor Snake",
          review: "Stretchy enough to fit my 50-foot frame! Plus, the moisture-wicking fabric is a lifesaver in the tropical heat.",
        },
        {
          photo: assets.avt1, // Replace with an actual photo URL
          name: "Titanoboa",
          designation: "King of Snakes",
          review: "As a 40-foot-long snake, I know a thing or two about needing a perfect fit! These shirts? Impressive. The fabric stretches better than my scales during a meal.",
        },
        {
          photo: assets.avt5, // Replace with an actual photo URL
          name: "T-Rex",
          designation: "Beast Incarnate",
          review: "I’ve got short arms but BIG style. These t-shirts? Absolutely Dino-mite! The fit is roar-some, and the designs are so sharp, they could rival my teeth.",
        },
        {
          photo: assets.avt9, // Replace with an actual photo URL
          name: "Megalodon",
          designation: "Monster of Sea",
          review: "As a 60-foot apex predator, I’ve seen the depths of the ocean, but these shirts? They're deeper in quality than the Mariana Trench!",
        },
        {
          photo: assets.avt2, // Replace with an actual photo URL
          name: "Mosasaurus",
          designation: "King of Marina Trench",
          review: "As a prehistoric marine reptile, fashion wasn’t really my thing back in the Cretaceous. But these T-shirts? Absolute legends!",
        },
        {
          photo: assets.avt6, // Replace with an actual photo URL
          name: "Diprotodon",
          designation: "",
          review: "As a prehistoric giant who’s all about comfort, I must say this brand hits the mark! The shirts are as soft as the grasslands.",
        },
        {
          photo: assets.avt10, // Replace with an actual photo URL
          name: "Quetzalcoatlus",
          designation: "Queen of Sky",
          review: "As a creature with a 40-foot wingspan, finding t-shirts that capture my soaring style is nearly impossible. But this brand? Absolutely sky-high!",
        },
        {
          photo: assets.avt3, // Replace with an actual photo URL
          name: "Ankylosaurus",
          designation: "",
          review: "As a dino built for protection, I know durable when I see it—and these t-shirts are rock-solid!",
        },
        {
          photo: assets.avt7, // Replace with an actual photo URL
          name: "Pterodactyl",
          designation: "Air Marshall",
          review: "As a high-flyer, I need t-shirts that can keep up with my aerial lifestyle! This brand? Absolutely soaring. The designs are bold enough to make me stand out.",
        },
        {
          photo: assets.avt11, // Replace with an actual photo URL
          name: "Brachiosaurus",
          designation: "Savior of Forest",
          review: "As a towering giant, I need a t-shirt that can handle my size. And let me tell you, this brand doesn’t disappoint! The material is sturdy yet breathable.",
        },
      ];
      
    
      const [currentIndex, setCurrentIndex] = useState(0);
      const cardsToShow = window.innerWidth >= 1024 ? 3 : window.innerWidth >= 768 ? 2 : 1; // Adjust this based on screen size
    
      const handlePrev = () => {
        // Scroll to the previous set of cards
        setCurrentIndex((prev) =>
          prev - cardsToShow < 0 ? 0 : prev - cardsToShow
        );
      };
    
      const handleNext = () => {
        // Scroll to the next set of cards
        setCurrentIndex((prev) =>
          prev + cardsToShow >= testimonialsData.length
            ? testimonialsData.length - cardsToShow
            : prev + cardsToShow
        );
      };
    
    
      const nextSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonialsData.length);
      };
    
      const prevSlide = () => {
        setCurrentIndex(
          (prevIndex) => (prevIndex - 1 + testimonialsData.length) % testimonialsData.length
        );
      };
  return (
    <div>
       {/* Testimonials Section */}
       <div className="my-10 bg-gray-100 rounded-sm p-6">
  {/* Heading */}
  <div className="text-center mb-8">
    <div className="inline-block bg-[#FF4902] text-white rounded-full px-4 py-2">
      <h2 className=" ">Testimonials</h2>
    </div>
    <p className="font-semibold text-3xl mt-4">What Mammals Are Saying</p>
  </div>

  {/* Cards */}
  <div className="relative mt-8 px-4 md:px-16"> {/* Adjusted padding for smaller screens */}
  {/* Left Button */}
  <button
    onClick={handlePrev}
    className="absolute left-0 top-1/2 transform -translate-y-1/2 bg-gray-300 p-2 rounded-full shadow-md hover:bg-gray-400 focus:outline-none"
  >
    &#8249; {/* Left arrow */}
  </button>

  {/* Testimonials Cards */}
  <div className="flex overflow-hidden">
    {testimonialsData.slice(currentIndex, currentIndex + cardsToShow).map((item, index) => (
      <div
        key={index}
        className="flex items-start bg-white rounded-lg shadow-lg mx-4 p-4 w-full sm:w-full md:w-1/3 lg:w-1/3 h-[280px] sm:h-[260px]" // Adjusted width for small and medium devices
      >
        <img
          src={item.photo}
          alt={`${item.name}`}
          className="w-16 h-16 rounded-full object-cover mr-4"
        />
        <div>
          <h3 className="font-bold text-lg">{item.name}</h3>
          <p className="text-sm text-gray-500">{item.designation}</p>
          <p className="mt-4 text-gray-700"> {`"`} {item.review} {`"`}</p>
        </div>
      </div>
    ))}
  </div>

  {/* Right Button */}
  <button
    onClick={handleNext}
    className="absolute right-0 top-1/2 transform -translate-y-1/2 bg-gray-300 p-2 rounded-full shadow-md hover:bg-gray-400 focus:outline-none"
  >
    &#8250; {/* Right arrow */}
  </button>

  {/* Navigation Dots */}
  <div className="flex justify-center mt-6">
    {Array.from({ length: Math.ceil(testimonialsData.length / cardsToShow) }).map((_, index) => (
      <div
        key={index}
        onClick={() => setCurrentIndex(index * cardsToShow)}
        className={`h-3 w-3 mx-1 rounded-full ${
          currentIndex / cardsToShow === index ? "bg-[#FF4902]" : "bg-gray-300"
        }`}
      ></div>
    ))}
  </div>
</div>
</div>
    </div>
  )
}

export default Testimonials
